// Module
var code = `<h2 class="section-header">Formula supports:</h2>
<div class="well well--table" ng-style="{'max-height': \$ctrl.maxHeight}">
  <table class="table">
    <tbody ng-repeat="item in \$ctrl.manual">
    <tr>
      <td class="manual__label-column label">Name:</td>
      <td class="manual__value-column">{{item.name}}</td>
    </tr>
    <tr>
      <td class="manual__label-column label">Example:</td>
      <td class="manual__value-column">{{item.example}}</td>
    </tr>
    <tr>
      <td class="manual__label-column label">Description:</td>
      <td class="manual__value-column">{{item.description}}</td>
    </tr>
    </tbody>
  </table>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/dynamic-report/mapping/manual/dynamic-report-mapping-manual.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;